import {AppConfig} from '@frontend/AppConfig'
import {useUserData} from '@frontend/hooks'
import {
    useAccountFlagsStore,
    useAuthStore,
} from '@frontend/stores'
import {DataPolling} from 'swayok-react-mdb-ui-kit/components/DataPolling/DataPolling'
import {UnauthorisedErrorHttpCode} from 'swayok-react-mdb-ui-kit/helpers/api/ApiRequestErrorHelpers'
import {useEventCallback} from 'swayok-react-mdb-ui-kit/helpers/useEventCallback'
import type {ApiError} from 'swayok-react-mdb-ui-kit/services/ApiRequestService'

// Поллинг данных пользователя.
export function GlobalDataPolling() {

    const reloadUserData = useAuthStore(
        state => state.reloadUserData
    )
    const onNotAuthorizedApiError = useAuthStore(
        state => state.onNotAuthorizedApiError
    )
    const isLoggedIn = !!useUserData()
    const loadFlags = useAccountFlagsStore(
        state => state.loadFlags
    )

    // Получить актуальные данные UI флагов пользователя (из кеша или загрузить из API).
    const handleUserFlagsPolling = useEventCallback(async (
        requestConfig: RequestInit
    ): Promise<void> => loadFlags(false, requestConfig)
        .catch(() => {
            // Игнорируем.
        }))

    // Получить актуальные данные пользователя (из кеша или загрузить из API).
    const handleUserInfoPolling = useEventCallback(async (
        requestConfig: RequestInit
    ): Promise<unknown> => reloadUserData(true, true, requestConfig)
        .catch((error: ApiError) => {
            if (error.status === UnauthorisedErrorHttpCode) {
                // Ошибка авторизации - выходим из ЛК.
                onNotAuthorizedApiError()
            }
        }))

    return (
        <>
            <DataPolling
                // Периодическое обновление данных пользователя.
                key="user-data-polling"
                condition={isLoggedIn}
                name={AppConfig.pollingName.userInfo}
                interval={AppConfig.userInfoPollingInterval}
                handler={handleUserInfoPolling}
            />
            <DataPolling
                // Периодическое обновление состояния различных флагов аккаунта.
                key="user-flags-polling"
                condition={isLoggedIn}
                name={AppConfig.pollingName.flags}
                interval={AppConfig.flagsPollingInterval}
                immediate
                handler={handleUserFlagsPolling}
            />
        </>
    )
}
